import { css } from "@emotion/react";
import { EuiPanel, EuiText, EuiSpacer } from "@inscopix/ideas-eui";
import { ButtonPermissioned } from "components/ButtonPermissioned/ButtonPermissioned";
import ModalDeleteProject from "components/ModalDeleteProject/ModalDeleteProject";
import ModalCloneProject from "components/ModalProject/ModalCloneProject";
import { projectScheduleDeleteAdminManageDjango } from "hooks/useProjectSheduleDeleteDjango/useProjectSheduleDeleteDjango";
import { useModalContext } from "providers/ModalProvider/ModalProvider";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";

interface ProjectActionsProps {
  projectId: string;
  tenantKey: string;
}

/**
 * Renders a permissioned buttons to copy and delete a project.
 * Opens a modal to clone the project when copy is clicked.
 * Consumes the {@link useModalContext} hook to manage modal state.
 */
export const ProjectActions = ({
  projectId,
  tenantKey,
}: ProjectActionsProps) => {
  const { openModal, closeModal } = useModalContext();
  const orgRoute = useRouteMapContext((s) => s.routeMap.ORGANIZATION);

  const goToOrganization = () => {
    orgRoute
      .dynamicPath({
        tenantKey,
      })
      .navigateTo();
  };
  return (
    <EuiPanel
      hasShadow={false}
      hasBorder={true}
      css={css`
        flex-grow: 0;
      `}
    >
      <EuiText size="s">
        <h3>Actions</h3>
      </EuiText>
      <EuiSpacer size="s" />
      <ButtonPermissioned
        iconType={"copy"}
        requiredPermission="download"
        onClick={() => {
          openModal(
            <ModalCloneProject projectId={projectId} onClose={closeModal} />,
          );
        }}
      >
        Copy
      </ButtonPermissioned>
      <EuiSpacer size="s" />
      <ButtonPermissioned
        iconType={"trash"}
        color={"danger"}
        requiredPermission="grant_access"
        onClick={() => {
          openModal(
            <ModalDeleteProject
              deleteProject={projectScheduleDeleteAdminManageDjango}
              projectId={projectId}
              onSuccess={goToOrganization}
              onClose={closeModal}
            />,
          );
        }}
      >
        Delete
      </ButtonPermissioned>
    </EuiPanel>
  );
};
